export default __webpack_public_path__ + "static/media/GiftSetProductInfo1_2.053664ba.jpg";